import React from 'react';

interface ILinkButtonProps {
  type?: 'button' | 'reset' | 'submit';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: any;
  [key: string]: any;
}

function LinkButton({ children, type, onClick, ...props }: ILinkButtonProps) {
  return (
    <button {...props} type={type || 'button'} onClick={onClick}>
      {children}
    </button>
  );
}

export default LinkButton;
